import Button from '@ingka/button';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import crossIcon from '@ingka/ssr-icon/paths/cross';
import {
  CHECKIN,
  REGISTERED,
  SELF_CHECKIN,
  WAITING_LIST,
} from '../Register/enums';
import CancelRegistrationModal from './CancelRegistrationModal';
import { TimeSlot } from '../../types/model';
import { isTimeSlotExpired } from '../../utils';

type PropsType = {
  registrationState: string;
  timeSlot: TimeSlot | null | undefined;
};

type CopyType = {
  [key: string]: {
    button: string;
  };
};

const CancelButton = styled(Button)`
  margin-top: var(--space-300);
`;

const CancelRegistration = ({ registrationState, timeSlot }: PropsType) => {
  const [showCancelModal, setShowCancelModal] = useState(false);
  const { t } = useTranslation();
  const isExpired = timeSlot ? isTimeSlotExpired(timeSlot) : false;

  const copy: CopyType = {
    [REGISTERED]: {
      button: 'event.cancelRegistration',
    },
    [CHECKIN]: {
      button: 'event.cancelRegistration',
    },
    [SELF_CHECKIN]: {
      button: 'event.cancelRegistration',
    },
    [WAITING_LIST]: {
      button: 'event.leaveWaitingList',
    },
  };

  return (
    <>
      <CancelButton
        type="secondary"
        text={t(copy[registrationState].button)}
        ssrIcon={crossIcon}
        onClick={() => setShowCancelModal(true)}
        disabled={isExpired}
      />
      {!isExpired && (
        <CancelRegistrationModal
          visible={showCancelModal}
          closeModal={() => setShowCancelModal(false)}
          registrationState={registrationState}
        />
      )}
    </>
  );
};

export default CancelRegistration;
